import React from 'react';
import { Sparkles } from 'lucide-react';
import type { Insight } from '../types';

interface Props {
  insights: Insight[];
}

// Cores semânticas padrão do sistema (red/amber/emerald), não a paleta exclusiva do documento original.
const CORES: Record<Insight['tipo'], string> = {
  alerta: '#dc2626',
  atencao: '#f59e0b',
  positivo: '#10b981',
};

const InsightsAutomaticos: React.FC<Props> = ({ insights }) => {
  return (
    <div>
      <h3 className="text-sm font-bold text-gray-800 dark:text-white mb-2 flex items-center gap-2">
        <Sparkles size={15} className="text-primary" />
        Insights em tempo real
      </h3>
      <div className="flex flex-col gap-2">
        {insights.map((insight, i) => (
          <div
            key={i}
            className="rounded-xl border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200 shadow-sm"
            style={{ borderLeft: `4px solid ${CORES[insight.tipo]}` }}
          >
            {insight.mensagem}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsAutomaticos;
